import * as accountsXhr from '../xhr/accounts.js';
import * as types from './types/invoices.js';
import * as notifier from './notifier.js';
import * as loader from './loader.js';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 * @returns {function(*=): Promise<T | never>}
 */
export function getInvoices(accountID) {
    return (dispatch) => {
        setLoader(dispatch, true);
        return accountsXhr.getInvoices(accountID)
            .then((invoices) => {
                dispatch({
                    type: types.GET_INVOICES_SUCCESS,
                    invoices
                });

                setLoader(dispatch, false);
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 * @param asoReportID
 * @returns {function(*=): Promise<T | never>}
 */
export function getAsoReport(asoReportID = false) {
    return (dispatch) => {
        setLoader(dispatch, true);
        return accountsXhr.getAsoReport(asoReportID)
            .then((data) => {
                setLoader(dispatch, false);
                return data.report;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 * @param accountID
 * @param billID
 * @returns {function(*=): Promise<unknown>}
 */
export function getInvoice(accountID, billID = false) {
    return (dispatch) => {
        setLoader(dispatch, true);
        return accountsXhr.getInvoice(accountID, billID)
            .then((data) => {
                dispatch({
                    type: types.GET_INVOICE_SUCCESS,
                    invoice: data.invoice
                });

                setLoader(dispatch, false);
                return data.invoice;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 * @param accountID
 * @param divisionID
 * @param invoiceNum
 */
export function triggerDivisionRepayment(accountID, divisionID, invoiceNum) {
    return (dispatch) => {
        setLoader(dispatch, true);
        return accountsXhr.triggerDivisionRepayment(accountID, divisionID, invoiceNum)
            .then(() => {
                setLoader(dispatch, false);
                dispatch(notifier.displayMessage("Division payment will be resent on the next invoice batch."));
                return true;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
                return false;
            });
    };
}

/**
 * @param invoiceNum
 * @param accountID
 * @returns {function(*=): Promise<any>}
 */
export function getCurrentInvoice(accountID = false) {

    return (dispatch) => {
        setLoader(dispatch, true);
        return accountsXhr.getCurrentInvoice(accountID)
            .then((currentInvoice) => {
                dispatch({
                    type: types.GET_CURRENT_INVOICE_SUCCESS,
                    invoice: currentInvoice
                });

                setLoader(dispatch, false);
                return currentInvoice;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 * @returns {Function}
 */
export function clearSelectedInvoice() {
    return (dispatch) => {
        dispatch({
            type: types.CLEAR_SELECTED_INVOICE
        });
    };
}

/**
 * @returns {Function}
 */
export function clearInvoices() {
    return (dispatch) => {
        dispatch({
            type: types.CLEAR_INVOICES
        });
    };
}

/**
 * 
 * @param {*} invoiceNum 
 * @param {*} accountID 
 * @param {*} isDivisionSummary 
 * @param {*} selectedDivisionID 
 * @param {*} fileName 
 * @returns 
 */
export function generateInvoiceSpreadsheet(invoiceNum, accountID, isDivisionSummary, selectedDivisionID, fileName) {
    return (dispatch) => accountsXhr.generateInvoiceSpreadsheet(invoiceNum, accountID, isDivisionSummary, selectedDivisionID)
        .then((data) => {
            if (data.isSentViaEmail === true) {
                return data;
            }

            const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${ data }`;
            const downloadLink = document.createElement("a");
                
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();

            return data; 
        })
        .catch((error) => {
            dispatch(notifier.displayError(error));
        });
}